import $ from 'jquery';

export default function searchPage() {
	const $search = $('.search');

	if ($search.length) {
		const $input = $search.find('#searchQ');

		if ($input.val() === '') {
			$input.focus();
		}
	}
}



// WEBPACK FOOTER //
// ./source/scripts/pages/search.js